import { useEffect, useMemo } from 'react'
import { useMutation } from '@apollo/client'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { useCustomerPaymentTokens } from 'lib/core/hooks'
import {
  commerceHubPaymentTokenDelete,
  DeletePaymentTokenOut
} from '../utils'

export const useCommerceHubTokens = () => {
  const { fetchPaymentTokens, paymentTokens, isFetching: vaultTokensLoading } = useCustomerPaymentTokens(
    {
      paymentMethodCode: PAYMENT_METHOD.COMMERCE_HUB
    }
  )

  const [deletePaymentToken, { loading: tokenIsDeleting }] = useMutation<{
    commerceHubPaymentTokenDelete: DeletePaymentTokenOut
  }>(commerceHubPaymentTokenDelete)

  const deleteToken = useMemo(() => {
    return (publicHash: string) => {
      deletePaymentToken({
        variables: {
          publicHash
        }
      }).then(() => {
        fetchPaymentTokens()
      })
    }
  }, [
    fetchPaymentTokens,
    deletePaymentToken
  ])

  useEffect(() => {
    fetchPaymentTokens()
  }, [fetchPaymentTokens])

  return {
    paymentTokens,
    deleteToken,
    tokensLoading: vaultTokensLoading,
    tokenIsDeleting
  }
}
